import type { InvoiceType } from '@recruitee/invoices-types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<InvoiceType>()('invoices');

export {
  actions as InvoicesCollectionActions,
  selectors as InvoicesCollectionSelectors,
  reducer as InvoicesCollectionReducer,
  namespace as InvoicesCollectionNamespace,
};
